import { useGlobalState } from "../../../components/global";

// 模块级缓存，用于存储 URL 到 Promise 的映射，解决并发和重复请求问题
const urlCache = new Map<string, Promise<string>>();
// 初始化缓存，用于存储不同类型OSS配置的Promise
const initCache = new Map<string, Promise<any>>();

export const useOSSFileUrl = () => {
    const { jsonRequest } = useGlobalState();

    // 获取oss签名数据（带缓存）
    const init = async (type: string) => {
        // 如果缓存中已存在该类型的请求，直接返回缓存的 Promise
        if (initCache.has(type)) {
            const cachedPromise = initCache.get(type);
            try {
                const cachedData = await cachedPromise;
                // 检查缓存数据是否过期
                if (cachedData && cachedData.expire) {
                    const expireTime = Number(cachedData.expire) * 1000;
                    if (expireTime < Date.now()) {
                        // 缓存过期，清除缓存并重新获取
                        initCache.delete(type);
                    } else {
                        // 缓存未过期，直接返回
                        return cachedData;
                    }
                } else {
                    // 没有过期时间信息，直接返回缓存数据
                    return cachedData;
                }
            } catch (error) {
                // 缓存的Promise出错，清除缓存
                initCache.delete(type);
            }
        }

        // 创建新的请求 Promise
        const requestPromise = jsonRequest.get("/common/oss-sign", {
            type: type,
        }).then((resp: any) => resp.json())
            .then((result: any) => result.data)
            .catch((error: any) => {
                console.error("获取OSS签名失败:", error);
                initCache.delete(type); // 失败时清除缓存
                return null;
            });

        // 将 Promise 存入缓存
        initCache.set(type, requestPromise);
        return requestPromise;
    };

    // 获取文件访问URL
    const getVisitUrl = async (url: string) => {
        if (!url || url.split('/').pop() === 'undefined') return '';

        // 如果缓存中已存在该 URL 的请求，直接返回缓存的 Promise
        if (urlCache.has(url)) {
            return urlCache.get(url) || '';
        }

        // 创建新的请求 Promise
        const requestPromise = jsonRequest.get(`/common/oss-file-visit-url`, { fileUrl: url })
            .then((resp: any) => resp.json())
            .then((result: any) => {
                if (!result?.data) {
                    urlCache.delete(url); // 失败移除缓存
                    return '';
                }
                return result.data;
            })
            .catch((error: any) => {
                console.error("获取文件访问URL失败:", error);
                urlCache.delete(url); // 失败移除缓存
                return '';
            });

        // 将 Promise 存入缓存
        urlCache.set(url, requestPromise);
        return requestPromise;
    };

    // 清除指定类型的初始化缓存并重新获取
    const clearInitCache = async (type: string) => {
        initCache.delete(type);
        // return await init(type);
    };

    return { init, getVisitUrl, clearInitCache };
};